const Style = {
  // Filters
  filterContainer: 'flex gap-4 mb-6',
  filterSelect: 'px-3 py-2 border border-slate-300 rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500',

  // Storage Usage
  storageContainer: 'p-2',
  storageHeader: 'flex items-baseline gap-1 mb-3',
  storageUsed: 'text-2xl font-bold text-slate-800',
  storageAllocated: 'text-sm text-slate-500',
  progressContainer: 'w-full h-3 bg-slate-200 rounded-full overflow-hidden',
  progressBar: 'h-full rounded-full transition-all duration-300',
  progressNormal: 'bg-emerald-500',
  progressWarning: 'bg-orange-500',
  progressCritical: 'bg-red-500',
  storageFooter: 'flex justify-between items-center mt-2',
  percentage: 'text-sm text-slate-600',
  warningText: 'text-xs text-orange-600',
  criticalText: 'text-xs text-red-600 font-medium',

  // Chart
  chartContainer: 'h-48 flex items-center justify-center',
  noData: 'flex items-center justify-center h-32 text-slate-400 text-sm',

  // Total Count
  totalCount: 'flex justify-center items-center gap-2 mt-6 pt-3 border-t border-slate-100',
  totalLabel: 'text-sm text-slate-500',
  totalValue: 'text-sm font-semibold text-slate-700',

  // Legend
  legendContainer: 'grid grid-cols-2 gap-2 mt-4 pt-4 border-t border-slate-100',
  legendItem: 'flex items-center gap-2',
  legendDotCustom: 'w-3 h-3 rounded-full flex-shrink-0',
  legendLabel: 'text-sm text-slate-600 flex-1 truncate',
  legendValue: 'text-sm font-semibold text-slate-800 flex items-center gap-1',
  legendPercent: 'text-xs font-normal text-slate-500',

  // Activity
  activityList: 'space-y-3 max-h-80 overflow-y-auto',
  activityItem: 'flex gap-3 p-2 rounded-lg hover:bg-slate-50 transition-colors',
  activityIcon: 'flex-shrink-0 w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center',
  activityContent: 'flex-1 min-w-0',
  activityTitle: 'text-sm text-slate-700',
  activityMeta: 'flex items-center gap-2 mt-1',
  activityDate: 'text-xs text-slate-400',

  // Alerts
  alertTitle: 'flex items-center gap-2',
  alertsList: 'space-y-2 max-h-80 overflow-y-auto',
  alertItem: 'flex items-start gap-3 p-3 rounded-lg',
  alertItemRed: 'bg-red-50',
  alertItemOrange: 'bg-orange-50',
  alertItemBlue: 'bg-blue-50',
  alertItemGray: 'bg-gray-50',
  alertIcon: 'flex-shrink-0 mt-0.5',
  alertContent: 'flex-1 min-w-0',
  alertName: 'text-sm font-medium text-slate-800',
  alertMeta: 'flex items-center gap-2 mt-1 flex-wrap',
  alertDetail: 'text-xs text-slate-500',
  noAlerts: 'flex flex-col items-center justify-center gap-2 py-8 text-slate-500 text-sm',

  // Alert Summary
  alertSummary: 'flex justify-center gap-6 mt-4 pt-4 border-t border-slate-100',
  summaryItem: 'flex flex-col items-center',
  summaryCount: 'text-lg font-bold',
  summaryHigh: 'text-red-600',
  summaryMedium: 'text-orange-600',
  summaryLow: 'text-gray-600',
  summaryLabel: 'text-xs text-slate-500',

  // See More
  seeMoreContainer: 'mt-4 pt-4 border-t border-slate-100 flex justify-center',

  // Alerts Page
  alertsPageHeader: 'flex justify-between items-center mb-6',
  alertsPageTitle: 'text-2xl font-bold text-slate-800',
  alertsFilters: 'flex gap-4 mb-6 flex-wrap',
  alertsGrid: 'space-y-3',
  alertsPagination: 'mt-6 flex justify-center',
};

export default Style;